import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFException34hypof9gkxss as EOFException } from './NonJvmPlatform.mjs';
import {
  selectPrefix5tb3rl5iltlw as selectPrefix,
  readUtf8Line36yidw3sdfobh as readUtf8Line,
} from './internal/Buffer.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSourceClass;
function RealBufferedSource() {
  if (RealBufferedSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.v3z_1 = source;
        this.w3z_1 = false;
        this.x3z_1 = new (Buffer())();
      }
      a3y() {
        return this.x3z_1;
      }
      e3z(sink, byteCount) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!this.w3z_1) {
            var message_0 = 'closed';
            throw IllegalStateException().o(toString(message_0));
          }
          if (this.x3z_1.k3v_1 === 0n) {
            var read = this.v3z_1.e3z(this.x3z_1, 8192n);
            if (read === -1n) {
              tmp$ret$4 = -1n;
              break $l$block;
            }
          }
          // Inline function 'kotlin.comparisons.minOf' call
          var b = this.x3z_1.k3v_1;
          var toRead = byteCount <= b ? byteCount : b;
          tmp$ret$4 = this.x3z_1.e3z(sink, toRead);
        }
        return tmp$ret$4;
      }
      b3y() {
        // Inline function 'okio.internal.commonExhausted' call
        // Inline function 'kotlin.check' call
        if (!!this.w3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        return this.x3z_1.b3y() && this.v3z_1.e3z(this.x3z_1, 8192n) === -1n;
      }
      c3y(byteCount) {
        // Inline function 'okio.internal.commonRequire' call
        if (!this.h3y(byteCount))
          throw EOFException().l3y();
        return Unit_instance;
      }
      h3y(byteCount) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'okio.internal.commonRequest' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!this.w3z_1) {
            var message_0 = 'closed';
            throw IllegalStateException().o(toString(message_0));
          }
          while (this.x3z_1.k3v_1 < byteCount) {
            if (this.v3z_1.e3z(this.x3z_1, 8192n) === -1n) {
              tmp$ret$4 = false;
              break $l$block;
            }
          }
          tmp$ret$4 = true;
        }
        return tmp$ret$4;
      }
      u3y(options) {
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'okio.internal.commonSelect' call
          // Inline function 'kotlin.check' call
          if (!!this.w3z_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          while (true) {
            var index = selectPrefix(this.x3z_1, options, true);
            switch (index) {
              case -1:
                tmp$ret$2 = -1;
                break $l$block_1;
              case -2:
                if (this.v3z_1.e3z(this.x3z_1, 8192n) === -1n) {
                  tmp$ret$2 = -1;
                  break $l$block_1;
                }

                break;
              default:
                var selectedSize = options.s3v_1[index].v2();
                this.x3z_1.l3v(fromInt(selectedSize));
                tmp$ret$2 = index;
                break $l$block_1;
            }
          }
        }
        return tmp$ret$2;
      }
      r3y() {
        return this.s3y(9223372036854775807n);
      }
      s3y(limit) {
        var tmp$ret$4;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8LineStrict' call
          // Inline function 'kotlin.require' call
          if (!(limit >= 0n)) {
            var message = 'limit < 0: ' + limit.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          var tmp;
          if (limit === 9223372036854775807n) {
            tmp = 9223372036854775807n;
          } else {
            // Inline function 'kotlin.Long.plus' call
            tmp = add(limit, fromInt(1));
          }
          var scanLength = tmp;
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(10);
          var tmp$ret$3 = Char__toInt_impl_vasixd(this_0);
          var newline = this.t3y(toByte(tmp$ret$3), 0n, scanLength);
          if (!(newline === -1n)) {
            tmp$ret$4 = readUtf8Line(this.x3z_1, newline);
            break $l$block_0;
          }
          var tmp_0;
          var tmp_1;
          var tmp_2;
          if (scanLength < 9223372036854775807n && this.h3y(scanLength)) {
            // Inline function 'kotlin.Long.minus' call
            var tmp$ret$5 = subtract(scanLength, fromInt(1));
            var tmp_3 = this.x3z_1.x3w(tmp$ret$5);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(13);
            var tmp$ret$6 = Char__toInt_impl_vasixd(this_1);
            tmp_2 = tmp_3 === toByte(tmp$ret$6);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$7 = add(scanLength, fromInt(1));
            tmp_1 = this.h3y(tmp$ret$7);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            var tmp_4 = this.x3z_1.x3w(scanLength);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(10);
            var tmp$ret$8 = Char__toInt_impl_vasixd(this_2);
            tmp_0 = tmp_4 === toByte(tmp$ret$8);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$4 = readUtf8Line(this.x3z_1, scanLength);
            break $l$block_0;
          }
          var data = new (Buffer())();
          // Inline function 'okio.minOf' call
          var b = this.x3z_1.k3v_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(32);
          var tmp$ret$10 = a <= b ? a : b;
          this.x3z_1.i3y(data, 0n, tmp$ret$10);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = this.x3z_1.k3v_1;
          var tmp$ret$11 = a_0 <= limit ? a_0 : limit;
          throw EOFException().g3y('\\n not found: limit=' + tmp$ret$11.toString() + ' content=' + data.m3y().l3x() + '\u2026');
        }
        return tmp$ret$4;
      }
      l3v(byteCount) {
        // Inline function 'okio.internal.commonSkip' call
        var byteCount_0 = byteCount;
        // Inline function 'kotlin.check' call
        if (!!this.w3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        while (byteCount_0 > 0n) {
          if (this.x3z_1.k3v_1 === 0n && this.v3z_1.e3z(this.x3z_1, 8192n) === -1n) {
            throw EOFException().l3y();
          }
          var tmp0 = byteCount_0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = this.x3z_1.k3v_1;
          var toSkip = tmp0 <= b ? tmp0 : b;
          this.x3z_1.l3v(toSkip);
          byteCount_0 = subtract(byteCount_0, toSkip);
        }
        return Unit_instance;
      }
      t3y(b, fromIndex, toIndex) {
        var tmp$ret$4;
        $l$block_0: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.check' call
          if (!!this.w3z_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!(0n <= fromIndex_0 ? fromIndex_0 <= toIndex : false)) {
            var message_0 = 'fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex.toString();
            throw IllegalArgumentException().s2(toString(message_0));
          }
          while (fromIndex_0 < toIndex) {
            var result = this.x3z_1.t3y(b, fromIndex_0, toIndex);
            if (!(result === -1n)) {
              tmp$ret$4 = result;
              break $l$block_0;
            }
            var lastBufferSize = this.x3z_1.k3v_1;
            if (lastBufferSize >= toIndex || this.v3z_1.e3z(this.x3z_1, 8192n) === -1n) {
              tmp$ret$4 = -1n;
              break $l$block_0;
            }
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = fromIndex_0;
            fromIndex_0 = a >= lastBufferSize ? a : lastBufferSize;
          }
          tmp$ret$4 = -1n;
        }
        return tmp$ret$4;
      }
      h3z(targetBytes) {
        return this.i3z(targetBytes, 0n);
      }
      i3z(targetBytes, fromIndex) {
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'okio.internal.commonIndexOfElement' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.check' call
          if (!!this.w3z_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          while (true) {
            var result = this.x3z_1.i3z(targetBytes, fromIndex_0);
            if (!(result === -1n)) {
              tmp$ret$2 = result;
              break $l$block_0;
            }
            var lastBufferSize = this.x3z_1.k3v_1;
            if (this.v3z_1.e3z(this.x3z_1, 8192n) === -1n) {
              tmp$ret$2 = -1n;
              break $l$block_0;
            }
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = fromIndex_0;
            fromIndex_0 = a >= lastBufferSize ? a : lastBufferSize;
          }
        }
        return tmp$ret$2;
      }
      j3z(offset, bytes) {
        return this.k3z(offset, bytes, 0, bytes.v2());
      }
      k3z(offset, bytes, bytesOffset, byteCount) {
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'okio.internal.commonRangeEquals' call
          // Inline function 'kotlin.check' call
          if (!!this.w3z_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          if (offset < 0n || bytesOffset < 0 || byteCount < 0 || (bytes.v2() - bytesOffset | 0) < byteCount) {
            tmp$ret$2 = false;
            break $l$block_1;
          }
          var inductionVariable = 0;
          if (inductionVariable < byteCount)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'kotlin.Long.plus' call
              var bufferOffset = add(offset, fromInt(i));
              // Inline function 'kotlin.Long.plus' call
              var tmp$ret$4 = add(bufferOffset, fromInt(1));
              if (!this.h3y(tmp$ret$4)) {
                tmp$ret$2 = false;
                break $l$block_1;
              }
              if (!(this.x3z_1.x3w(bufferOffset) === bytes.w2(bytesOffset + i | 0))) {
                tmp$ret$2 = false;
                break $l$block_1;
              }
            }
             while (inductionVariable < byteCount);
          tmp$ret$2 = true;
        }
        return tmp$ret$2;
      }
      q6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.w3z_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          this.w3z_1 = true;
          this.v3z_1.q6();
          this.x3z_1.f5();
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.v3z_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSource');
    RealBufferedSourceClass = $;
  }
  return RealBufferedSourceClass;
}
//region block: exports
export {
  RealBufferedSource as RealBufferedSource2k7dkofmgqbx9,
};
//endregion

//# sourceMappingURL=RealBufferedSource.mjs.map
